import { useRef, useState } from "react";
import { Volume2 } from "lucide-react";
import { fetchAcharyaAudio } from "@/lib/acharya/acharya-service";

function resolveSrc(payload) {
  if (!payload) return null;
  if (payload.url) return payload.url;
  if (payload.audio_base64 && payload.mime_type) {
    return `data:${payload.mime_type};base64,${payload.audio_base64}`;
  }
  return null;
}

/**
 * Phase 5A — Śloka audio only (śāstra mode). Uses mode="gita_sloka" — never mantra registry.
 */
export function GitaAudioIcon({
  audioRef,
  verseText,
  iastText,
  token,
  title = "Listen to śloka",
  size = 18,
}) {
  const [loading, setLoading] = useState(false);
  const [src, setSrc] = useState(null);
  const audioEl = useRef(null);

  const play = async () => {
    if (loading) return;
    const text = (verseText || iastText || "").trim();
    if (!text) return;
    try {
      setLoading(true);
      if (!src) {
        const payload = await fetchAcharyaAudio(text, "gita_sloka", token, { audio_ref: audioRef });
        const s = resolveSrc(payload);
        if (s) setSrc(s);
        queueMicrotask(() => audioEl.current?.play?.().catch(() => {}));
      } else {
        await audioEl.current?.play?.().catch(() => {});
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <span className="inline-flex items-center" data-testid="gita-audio-icon">
      <button
        type="button"
        onClick={play}
        title={title}
        aria-label={loading ? "Loading śloka audio" : title}
        className="inline-flex items-center justify-center rounded-sm text-muted-foreground hover:text-foreground transition-colors"
        style={{ width: size + 6, height: size + 6 }}
      >
        <Volume2 width={size} height={size} />
      </button>
      <audio ref={audioEl} src={src ?? undefined} preload="auto" />
    </span>
  );
}
